const WhatsAppButton = () => {
  const phone = "85511944544";
  const message = encodeURIComponent(
    "Hello Aṅkor Sojourns, I'd like to learn more about your tours."
  );
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 hidden md:flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-soft hover:scale-105 active:scale-95 transition-transform px-5 py-4"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="h-6 w-6 md:h-7 md:w-7"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.674.244-1.03 0-.717-1.448-1.04-1.706-1.146z m-2.13-7.792c-4.296 0-7.79 3.494-7.79 7.79 0 1.385.387 2.74 1.117 3.92l-1.36 4.024 4.16-1.333a7.74 7.74 0 0 0 3.873 1.052h.004c4.296 0 7.79-3.494 7.79-7.79 0-2.08-.81-4.038-2.282-5.51a7.747 7.747 0 0 0-5.512-2.28zm6.78 14.79a9.46 9.46 0 0 1-6.78 2.81h-.005a9.46 9.46 0 0 1-4.524-1.153L7.5 27l1.32-3.911a9.426 9.426 0 0 1-1.262-4.713c0-5.214 4.243-9.456 9.46-9.456a9.41 9.41 0 0 1 6.692 2.774 9.408 9.408 0 0 1 2.77 6.692 9.46 9.46 0 0 1-2.769 6.692z" />
      </svg>
      <span className="hidden md:inline text-sm font-medium tracking-wide">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
